import React, { useState, useEffect } from 'react';
import './ManagerSourcing.css';
// import { RAZORPAY_KEY_ID } from '../../../config/api';

const ManagerSourcing = () => {
  // Table data with all fields
  const [tableData, setTableData] = useState([
    {
      id: 1,
      srNo: 1,
      leadName: 'Rohit Sharma',
      mobile: '+91 98765 43210',
      email: 'rohit@acme.in',
      whatsapp: '+91 98765 43210',
      company: 'Acme Industries',
      source: 'Referral',
      location: 'Mumbai',
      assigned: 'Priya (Exec)',
      status: 'New',
      enquiryDate: '2024-01-15',
      description: 'Looking for industrial automation solutions',
      vertical: 'Manufacturing & Automation',
      activity: 'Demo scheduled',
      remarks: 'Follow up in Q3',
      paymentStatus: 'Pending',
      amount: 150,
      isFree: false,
      teamLead: 'Rajesh (Manager)'
    },
    {
      id: 2,
      srNo: 2,
      leadName: 'Anita Desai',
      mobile: '+91 87654 32109',
      email: 'anita@nimbus.io',
      whatsapp: '+91 87654 32109',
      company: 'Nimbus Tech',
      source: 'Internet Research',
      location: 'Bangalore',
      assigned: 'Karan (Exec)',
      status: 'In Review',
      enquiryDate: '2024-01-15',
      description: 'Interested in cloud migration services',
      vertical: 'IT & Cloud Services',
      activity: 'Initial call done',
      remarks: 'Send proposal by EOW',
      paymentStatus: 'Paid',
      amount: 250,
      isFree: false,
      teamLead: 'Rajesh (Manager)'
    },
    {
      id: 3,
      srNo: 3,
      leadName: 'Vikram Mehta',
      mobile: '+91 76543 21098',
      email: 'vikram@orbit.co',
      whatsapp: '+91 76543 21098',
      company: 'Orbit Logistics',
      source: 'Social Media',
      location: 'Delhi',
      assigned: 'Priya (Exec)',
      status: 'New',
      enquiryDate: '2024-01-15',
      description: 'Needs fleet management software',
      vertical: 'Logistics & Supply Chain',
      activity: 'Requirement gathering',
      remarks: 'Demo scheduled for Monday',
      paymentStatus: 'Pending',
      amount: 350,
      isFree: false,
      teamLead: 'Rajesh (Manager)'
    },
    {
      id: 4,
      srNo: 4,
      leadName: 'Sara Khan',
      mobile: '+91 65432 10987',
      email: 'sara@bluepeak.in',
      whatsapp: '+91 65432 10987',
      company: 'BluePeak Foods',
      source: 'Physical Visit',
      location: 'Pune',
      assigned: 'Karan (Exec)',
      status: 'Converted',
      enquiryDate: '2024-01-15',
      description: 'Interested in cold storage monitoring',
      vertical: 'Food & Beverage',
      activity: 'Product intro sent',
      remarks: 'Share brochure',
      paymentStatus: 'Paid',
      amount: 180,
      isFree: false,
      teamLead: 'Rajesh (Manager)'
    },
    {
      id: 5,
      srNo: 5,
      leadName: 'Free User',
      mobile: '+91 12345 67890',
      email: 'free@demo.com',
      whatsapp: '+91 12345 67890',
      company: 'Free Demo Corp',
      source: 'Referral',
      location: 'Mumbai',
      assigned: 'Admin',
      status: 'New',
      enquiryDate: '2024-01-20',
      description: 'Free trial lead - no payment needed',
      vertical: 'Demo',
      activity: 'Free access granted',
      remarks: 'No payment required',
      paymentStatus: 'N/A',
      amount: 0,
      isFree: true,
      teamLead: 'Rajesh (Manager)'
    }
  ]);

  const [isNewLeadModalOpen, setIsNewLeadModalOpen] = useState(false);
  const [isBulkUploadModalOpen, setIsBulkUploadModalOpen] = useState(false);
  const [isConvertModalOpen, setIsConvertModalOpen] = useState(false);
  const [isViewModalOpen, setIsViewModalOpen] = useState(false);
  const [isAssignModalOpen, setIsAssignModalOpen] = useState(false);
  const [selectedLead, setSelectedLead] = useState(null);
  const [bulkData, setBulkData] = useState('');
  const [processingPaymentId, setProcessingPaymentId] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [selectedAssignee, setSelectedAssignee] = useState('');

  // Team members data
  const teamMembers = [
    { id: 1, name: 'Priya (Exec)', role: 'Senior Executive', currentLoad: 8, maxLoad: 15 },
    { id: 2, name: 'Karan (Exec)', role: 'Executive', currentLoad: 6, maxLoad: 15 },
    { id: 3, name: 'Aarav (Admin)', role: 'Admin', currentLoad: 4, maxLoad: 10 },
    { id: 4, name: 'Neha (Manager)', role: 'Manager', currentLoad: 3, maxLoad: 8 },
    { id: 5, name: 'Raj (Sales)', role: 'Sales Lead', currentLoad: 7, maxLoad: 12 }
  ];

  const [formData, setFormData] = useState({
    leadName: '',
    mobile: '',
    email: '',
    whatsapp: '',
    company: '',
    source: 'Internet Research',
    location: '',
    assignedTo: 'Priya (Exec)',
    enquiryDate: '',
    description: '',
    vertical: '',
    activity: '',
    remarks: '',
    notes: '',
    amount: '',
    isFree: false,
    teamLead: 'Rajesh (Manager)'
  });

  const sourceOptions = ['Referral', 'Internet Research', 'Social Media', 'Physical Visit', 'Cold Call', 'Email Campaign'];
  const assigneeOptions = ['Priya (Exec)', 'Karan (Exec)', 'Aarav (Admin)', 'Neha (Manager)', 'Raj (Sales)'];

  // Calculate statistics
  const stats = {
    totalLeads: tableData.length,
    newLeads: tableData.filter(l => l.status === 'New').length,
    convertedLeads: tableData.filter(l => l.status === 'Converted').length,
    inReviewLeads: tableData.filter(l => l.status === 'In Review').length,
    totalRevenue: tableData.filter(l => l.paymentStatus === 'Paid').reduce((sum, l) => sum + l.amount, 0),
    pendingPayment: tableData.filter(l => l.paymentStatus === 'Pending').reduce((sum, l) => sum + l.amount, 0)
  };

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  const handleAddLead = () => {
    if (!formData.leadName || !formData.email || !formData.company) {
      alert('Please fill required fields: Lead Name, Email, and Company');
      return;
    }

    const newId = tableData.length + 1;
    const newLead = {
      id: newId,
      srNo: newId,
      leadName: formData.leadName,
      mobile: formData.mobile || 'Not Provided',
      email: formData.email,
      whatsapp: formData.whatsapp || formData.mobile || 'Not Provided',
      company: formData.company,
      source: formData.source,
      location: formData.location || 'Not Specified',
      assigned: formData.assignedTo,
      status: 'New',
      description: formData.description || '',
      vertical: formData.vertical || '',
      activity: formData.activity || '',
      remarks: formData.remarks || '',
      enquiryDate: formData.enquiryDate || new Date().toISOString().split('T')[0],
      paymentStatus: formData.isFree ? 'N/A' : 'Pending',
      amount: formData.amount ? parseFloat(formData.amount) : 0,
      isFree: formData.isFree,
      teamLead: 'Rajesh (Manager)'
    };

    setTableData([...tableData, newLead]);
    setFormData({
      leadName: '',
      mobile: '',
      email: '',
      whatsapp: '',
      company: '',
      source: 'Internet Research',
      location: '',
      assignedTo: 'Priya (Exec)',
      description: '',
      vertical: '',
      activity: '',
      remarks: '',
      notes: '',
      enquiryDate: '',
      amount: '',
      isFree: false,
      teamLead: 'Rajesh (Manager)'
    });
    setIsNewLeadModalOpen(false);
    alert('Lead added successfully!');
  };

  const handleConvertLead = () => {
    if (selectedLead) {
      if (!selectedLead.isFree && selectedLead.paymentStatus !== 'Paid') {
        alert('⚠️ Payment required before conversion! Please complete the payment first.');
        return;
      }
      const updatedTableData = tableData.map(lead =>
        lead.id === selectedLead.id ? { ...lead, status: 'Converted' } : lead
      );
      setTableData(updatedTableData);
      alert(`✅ Lead "${selectedLead.leadName}" converted to Enquiry successfully!`);
      setIsConvertModalOpen(false);
      setSelectedLead(null);
    }
  };

  const handleReassignLead = () => {
    if (selectedLead && selectedAssignee) {
      const updatedTableData = tableData.map(lead =>
        lead.id === selectedLead.id ? { ...lead, assigned: selectedAssignee } : lead
      );
      setTableData(updatedTableData);
      alert(`✅ Lead reassigned to ${selectedAssignee} successfully!`);
      setIsAssignModalOpen(false);
      setSelectedLead(null);
      setSelectedAssignee('');
    }
  };

  const openConvertModal = (lead) => {
    if (!lead.isFree && lead.paymentStatus !== 'Paid') {
      alert('⚠️ Please complete the payment before converting this lead.');
      return;
    }
    setSelectedLead(lead);
    setIsConvertModalOpen(true);
  };

  const openViewModal = (lead) => {
    setSelectedLead(lead);
    setIsViewModalOpen(true);
  };

  const openAssignModal = (lead) => {
    setSelectedLead(lead);
    setSelectedAssignee(lead.assigned);
    setIsAssignModalOpen(true);
  };

  const handleBulkUpload = () => {
    if (!bulkData.trim()) {
      alert('Please paste CSV data');
      return;
    }
    const rows = bulkData.split('\n');
    const newLeads = [];
    let startIndex = 0;
    const firstRow = rows[0].toLowerCase();
    if (firstRow.includes('lead name') || firstRow.includes('name')) {
      startIndex = 1;
    }
    for (let i = startIndex; i < rows.length; i++) {
      const cols = rows[i].split(',');
      if (cols.length >= 4 && cols[0]?.trim()) {
        const newId = tableData.length + newLeads.length + 1;
        const isFree = cols[14]?.trim().toLowerCase() === 'true' || cols[14]?.trim().toLowerCase() === 'free';
        const leadData = {
          id: newId,
          srNo: newId,
          leadName: cols[0]?.trim() || 'Unknown',
          mobile: cols[1]?.trim() || 'Not Provided',
          email: cols[2]?.trim() || 'unknown@email.com',
          whatsapp: cols[3]?.trim() || cols[1]?.trim() || 'Not Provided',
          company: cols[4]?.trim() || 'Unknown Company',
          source: cols[5]?.trim() || 'Other',
          location: cols[6]?.trim() || 'Not Specified',
          assigned: cols[7]?.trim() || 'Priya (Exec)',
          status: 'New',
          description: cols[8]?.trim() || '',
          vertical: cols[9]?.trim() || '',
          activity: cols[10]?.trim() || '',
          remarks: cols[11]?.trim() || '',
          enquiryDate: cols[12]?.trim() || new Date().toISOString().split('T')[0],
          paymentStatus: isFree ? 'N/A' : 'Pending',
          amount: parseFloat(cols[13]?.trim()) || 0,
          isFree: isFree,
          teamLead: 'Rajesh (Manager)'
        };
        newLeads.push(leadData);
      }
    }
    if (newLeads.length > 0) {
      setTableData([...tableData, ...newLeads]);
      alert(`Successfully added ${newLeads.length} leads!`);
      setIsBulkUploadModalOpen(false);
      setBulkData('');
    } else {
      alert('No valid data found. Please check your format.');
    }
  };

  const loadRazorpayScript = () => {
    return new Promise((resolve) => {
      if (window.Razorpay) {
        resolve(true);
        return;
      }
      const script = document.createElement('script');
      script.src = 'https://checkout.razorpay.com/v1/checkout.js';
      script.onload = () => resolve(true);
      script.onerror = () => resolve(false);
      document.body.appendChild(script);
    });
  };

  const handleDirectPayment = async (lead) => {
    if (lead.paymentStatus === 'Paid') {
      alert('Payment already completed for this lead.');
      return;
    }
    if (lead.isFree) {
      alert('This is a free lead. No payment required.');
      return;
    }
    setProcessingPaymentId(lead.id);
    const scriptLoaded = await loadRazorpayScript();
    if (!scriptLoaded) {
      alert('Failed to load Razorpay SDK. Please check your internet connection.');
      setProcessingPaymentId(null);
      return;
    }
    const options = {
      // key: `${RAZORPAY_KEY_ID}`,
      amount: Math.round(lead.amount * 100),
      currency: 'INR',
      name: lead.company || 'Company',
      description: `Payment for ${lead.leadName}`,
      image: 'https://your-logo-url.com/logo.png',
      order_id: '',
      handler: function (response) {
        const paymentId = response.razorpay_payment_id;
        setTableData(prevData =>
          prevData.map(item =>
            item.id === lead.id ? { ...item, paymentStatus: 'Paid' } : item
          )
        );
        alert(`✅ Payment Successful!\n\nPayment ID: ${paymentId}\nAmount: ₹${lead.amount}\n\nYou can now convert this lead.`);
        setProcessingPaymentId(null);
      },
      prefill: {
        name: lead.leadName,
        email: lead.email,
        contact: lead.mobile,
      },
      notes: {
        lead_id: lead.id.toString(),
        lead_name: lead.leadName,
        company: lead.company,
      },
      theme: { color: '#1e7e34' },
      modal: {
        ondismiss: function () {
          alert('Payment cancelled by user.');
          setProcessingPaymentId(null);
        }
      }
    };
    const razorpay = new window.Razorpay(options);
    razorpay.on('payment.failed', function (response) {
      const error = response.error;
      alert(`❌ Payment Failed: ${error.description || 'Please try again'}`);
      setTableData(prevData =>
        prevData.map(item =>
          item.id === lead.id ? { ...item, paymentStatus: 'Failed' } : item
        )
      );
      setProcessingPaymentId(null);
    });
    razorpay.open();
  };

  const filteredData = tableData.filter(lead => {
    const matchesSearch =
      lead.amount.toString().includes(searchTerm) ||
      lead.assigned.toLowerCase().includes(searchTerm.toLowerCase()) ||
      lead.source.toLowerCase().includes(searchTerm.toLowerCase()) ||
      lead.leadName.toLowerCase().includes(searchTerm.toLowerCase()) ||
      lead.company.toLowerCase().includes(searchTerm.toLowerCase()) ||
      lead.email.toLowerCase().includes(searchTerm.toLowerCase()) ||
      lead.mobile.includes(searchTerm) ||
      lead.status.toLowerCase().includes(searchTerm.toLowerCase());
    
    let matchesDate = true;
    if (startDate && lead.enquiryDate) matchesDate = matchesDate && lead.enquiryDate >= startDate;
    if (endDate && lead.enquiryDate) matchesDate = matchesDate && lead.enquiryDate <= endDate;
    return matchesSearch && matchesDate;
  });

  const clearFilters = () => {
    setSearchTerm('');
    setStartDate('');
    setEndDate('');
  };

  const getPaymentInfo = (lead) => {
    if (lead.isFree) return { text: 'Free', disabled: true, className: 'mgr-payment-free' };
    if (lead.paymentStatus === 'Paid') return { text: '✓ Paid', disabled: true, className: 'mgr-payment-paid' };
    if (lead.paymentStatus === 'Failed') return { text: 'Retry', disabled: false, className: 'mgr-payment-failed' };
    if (processingPaymentId === lead.id) return { text: 'Processing...', disabled: true, className: 'mgr-payment-processing' };
    return { text: `Pay ₹${lead.amount}`, disabled: false, className: 'mgr-payment-pending' };
  };

  const getStatusClass = (status) => {
    switch(status.toLowerCase()) {
      case 'new': return 'mgr-status-new';
      case 'converted': return 'mgr-status-converted';
      case 'in review': return 'mgr-status-in-review';
      case 'approved': return 'mgr-status-approved';
      default: return 'mgr-status-new';
    }
  };

  return (
    <div className="mgr-container">
      <div className="mgr-wrapper">
        
        <div className="mgr-filter-section">
          <div className="mgr-filter-left">
            <div className="mgr-search-box">
              <span className="mgr-search-icon">🔍</span>
              <input 
                type="text" 
                placeholder="Search by name, company, email, status..." 
                value={searchTerm} 
                onChange={(e) => setSearchTerm(e.target.value)} 
                className="mgr-search-input" 
              />
            </div>
            <div className="mgr-date-filters">
              <input 
                type="date" 
                className="mgr-date-input" 
                value={startDate} 
                onChange={(e) => setStartDate(e.target.value)} 
                placeholder="From Date"
              />
              <span className="mgr-date-sep">→</span>
              <input 
                type="date" 
                className="mgr-date-input" 
                value={endDate} 
                onChange={(e) => setEndDate(e.target.value)} 
                placeholder="To Date"
              />
              {(startDate || endDate || searchTerm) && (
                <button className="mgr-clear-filters" onClick={clearFilters}>✕ Clear</button>
              )}
            </div>
          </div>
          <div className="mgr-table-actions">
            <button className="mgr-bulk-button" onClick={() => setIsBulkUploadModalOpen(true)}>📤 Bulk Upload</button>
            <button className="mgr-new-button" onClick={() => setIsNewLeadModalOpen(true)}>+ New Lead</button>
          </div>
        </div>

        <div className="mgr-table-section">
          <div className="mgr-table-container">
            <table className="mgr-table">
              <thead>
                <tr>
                  <th>Sr.No</th>
                  <th>Date</th>
                  <th>Lead Name</th>
                  <th>Company</th>
                  <th>Source</th>
                  <th>Assigned To</th>
                  <th>Vertical</th>
                  <th>Activity</th>
                  <th>Status</th>
                  {/* <th>Payment</th> */}
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {filteredData.map((lead) => {
                  const paymentInfo = getPaymentInfo(lead);
                  return (
                    <tr key={lead.id}>
                      <td data-label="Sr.No">{lead.srNo}</td>
                      <td data-label="Date">{lead.enquiryDate}</td>
                      <td data-label="Lead Name">
                        {lead.leadName}
                        {lead.isFree && <span className="mgr-free-badge">FREE</span>}
                      </td>
                      <td data-label="Company">{lead.company}</td>
                      <td data-label="Source">{lead.source}</td>
                      <td data-label="Assigned To">{lead.assigned}</td>
                      <td data-label="Vertical">{lead.vertical}</td>
                      <td data-label="Activity">{lead.activity}</td>
                      <td data-label="Status">
                        <span className={`mgr-status ${getStatusClass(lead.status)}`}>{lead.status}</span>
                      </td>
                      {/* <td data-label="Payment">
                        {lead.status === "New" || lead.status === "In Review" ? (
                          <button 
                            className={`mgr-payment-btn ${paymentInfo.className}`} 
                            onClick={() => handleDirectPayment(lead)} 
                            disabled={paymentInfo.disabled}
                          >
                            {paymentInfo.text}
                          </button>
                        ) : (
                          <span className="mgr-payment-paid" style={{padding: '4px 12px', borderRadius: '20px'}}>✓ Completed</span>
                        )}
                      </td> */}
                      <td data-label="Actions">
                        <div className="mgr-action-group">
                          {lead.status === "New" || lead.status === "In Review" ? (
                            <button 
                              className="mgr-convert-btn" 
                              onClick={() => openConvertModal(lead)} 
                              disabled={!lead.isFree && lead.paymentStatus !== "Paid"}
                            >
                              Convert
                            </button>
                          ) : (
                            <button className="mgr-view-btn" onClick={() => openViewModal(lead)}>View</button>
                          )}
                          <button className="mgr-assign-btn" onClick={() => openAssignModal(lead)}>Assign</button>
                        </div>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
            {filteredData.length === 0 && (
              <div className="mgr-no-results">No leads found matching your criteria</div>
            )}
          </div>
        </div>
      </div>

      {/* New Lead Modal */}
      {isNewLeadModalOpen && (
        <div className="mgr-modal-overlay" onClick={() => setIsNewLeadModalOpen(false)}>
          <div className="mgr-modal mgr-large-modal" onClick={(e) => e.stopPropagation()}>
            <div className="mgr-modal-header">
              <h3>➕ Add New Lead</h3>
              <button className="mgr-modal-close" onClick={() => setIsNewLeadModalOpen(false)}>×</button>
            </div>
            <div className="mgr-modal-body">
              <div className="mgr-form-row">
                <div className="mgr-form-group">
                  <label>Lead Name <span className="mgr-required">*</span></label>
                  <input type="text" name="leadName" value={formData.leadName} onChange={handleInputChange} placeholder="Enter full name" />
                </div>
                <div className="mgr-form-group">
                  <label>Mobile Number</label>
                  <input type="text" name="mobile" value={formData.mobile} onChange={handleInputChange} placeholder="+91 XXXXXXXXXX" />
                </div>
              </div>
              <div className="mgr-form-row">
                <div className="mgr-form-group">
                  <label>Email <span className="mgr-required">*</span></label>
                  <input type="email" name="email" value={formData.email} onChange={handleInputChange} placeholder="email@company.com" />
                </div>
                <div className="mgr-form-group">
                  <label>WhatsApp</label>
                  <input type="text" name="whatsapp" value={formData.whatsapp} onChange={handleInputChange} placeholder="WhatsApp number" />
                </div>
              </div>
              <div className="mgr-form-row">
                <div className="mgr-form-group">
                  <label>Company <span className="mgr-required">*</span></label>
                  <input type="text" name="company" value={formData.company} onChange={handleInputChange} placeholder="Company name" />
                </div>
                <div className="mgr-form-group">
                  <label>Enquiry Date</label>
                  <input type="date" name="enquiryDate" value={formData.enquiryDate} onChange={handleInputChange} />
                </div>
              </div>
              <div className="mgr-form-row">
                <div className="mgr-form-group">
                  <label>Source</label>
                  <select name="source" value={formData.source} onChange={handleInputChange}>
                    {sourceOptions.map(opt => <option key={opt} value={opt}>{opt}</option>)}
                  </select>
                </div>
                <div className="mgr-form-group">
                  <label>Location</label>
                  <input type="text" name="location" value={formData.location} onChange={handleInputChange} placeholder="City, State" />
                </div>
              </div>
              <div className="mgr-form-row">
                <div className="mgr-form-group">
                  <label>Assign To</label>
                  <select name="assignedTo" value={formData.assignedTo} onChange={handleInputChange}>
                    {assigneeOptions.map(opt => <option key={opt} value={opt}>{opt}</option>)}
                  </select>
                </div>
                <div className="mgr-form-group">
                  <label>Vertical</label>
                  <input type="text" name="vertical" value={formData.vertical} onChange={handleInputChange} placeholder="e.g., IT, Manufacturing" />
                </div>
              </div>
              <div className="mgr-form-row">
                <div className="mgr-form-group">
                  <label>Amount (₹)</label>
                  <input type="number" name="amount" value={formData.amount} onChange={handleInputChange} placeholder="0" />
                </div>
                <div className="mgr-form-group">
                  <label>Activity</label>
                  <input type="text" name="activity" value={formData.activity} onChange={handleInputChange} placeholder="Current status" />
                </div>
              </div>
              <div className="mgr-form-row">
                <div className="mgr-form-group mgr-checkbox-group">
                  <label className="mgr-checkbox-label">
                    <input type="checkbox" name="isFree" checked={formData.isFree} onChange={handleInputChange} />
                    <span> Free Lead (No payment required)</span>
                  </label>
                </div>
              </div>
              <div className="mgr-form-row">
                <div className="mgr-form-group mgr-full-width">
                  <label>Description</label>
                  <textarea name="description" value={formData.description} onChange={handleInputChange} rows="2" placeholder="Lead requirements..."></textarea>
                </div>
              </div>
              <div className="mgr-form-row">
                <div className="mgr-form-group mgr-full-width">
                  <label>Remarks</label>
                  <textarea name="remarks" value={formData.remarks} onChange={handleInputChange} rows="2" placeholder="Additional notes..."></textarea>
                </div>
              </div>
            </div>
            <div className="mgr-modal-footer">
              <button className="mgr-cancel-button" onClick={() => setIsNewLeadModalOpen(false)}>Cancel</button>
              <button className="mgr-save-button" onClick={handleAddLead}>Save Lead</button>
            </div>
          </div>
        </div>
      )}

      {/* Convert Modal */}
      {isConvertModalOpen && selectedLead && (
        <div className="mgr-modal-overlay" onClick={() => setIsConvertModalOpen(false)}>
          <div className="mgr-modal" onClick={(e) => e.stopPropagation()}>
            <div className="mgr-modal-header">
              <h3>🔄 Convert to Enquiry</h3>
              <button className="mgr-modal-close" onClick={() => setIsConvertModalOpen(false)}>×</button>
            </div>
            <div className="mgr-modal-body">
              <p>Are you sure you want to convert this lead to an enquiry?</p>
              <div className="mgr-convert-preview">
                <div><strong>Lead:</strong> {selectedLead.leadName}</div>
                <div><strong>Company:</strong> {selectedLead.company}</div>
                <div><strong>Email:</strong> {selectedLead.email}</div>
                <div><strong>Mobile:</strong> {selectedLead.mobile}</div>
                <div><strong>Amount:</strong> ₹{selectedLead.amount?.toLocaleString() || '0'}</div>
                {selectedLead.isFree && <div><strong>Type:</strong> 🆓 Free Lead</div>}
                {!selectedLead.isFree && selectedLead.paymentStatus === 'Paid' && <div><strong>Payment:</strong> ✅ Completed</div>}
              </div>
              <p className="mgr-convert-note">After conversion, the lead will be moved to enquiries section.</p>
            </div>
            <div className="mgr-modal-footer">
              <button className="mgr-cancel-button" onClick={() => setIsConvertModalOpen(false)}>Cancel</button>
              <button className="mgr-convert-button-modal" onClick={handleConvertLead}>Confirm Convert</button>
            </div>
          </div>
        </div>
      )}

      {/* View Modal */}
      {isViewModalOpen && selectedLead && (
        <div className="mgr-modal-overlay" onClick={() => setIsViewModalOpen(false)}>
          <div className="mgr-modal mgr-large-modal" onClick={(e) => e.stopPropagation()}>
            <div className="mgr-modal-header">
              <h3>📄 Lead Details</h3>
              <button className="mgr-modal-close" onClick={() => setIsViewModalOpen(false)}>×</button>
            </div>
            <div className="mgr-modal-body">
              <div className="mgr-view-details">
                <div className="mgr-view-section">
                  <h4>Contact Information</h4>
                  <div className="mgr-view-grid">
                    <div><strong>Lead Name:</strong> {selectedLead.leadName}</div>
                    <div><strong>Company:</strong> {selectedLead.company}</div>
                    <div><strong>Email:</strong> {selectedLead.email}</div>
                    <div><strong>Mobile:</strong> {selectedLead.mobile}</div>
                    <div><strong>WhatsApp:</strong> {selectedLead.whatsapp}</div>
                    <div><strong>Location:</strong> {selectedLead.location}</div>
                  </div>
                </div>
                <div className="mgr-view-section">
                  <h4>Lead Information</h4>
                  <div className="mgr-view-grid">
                    <div><strong>Source:</strong> {selectedLead.source}</div>
                    <div><strong>Assigned To:</strong> {selectedLead.assigned}</div>
                    <div><strong>Enquiry Date:</strong> {selectedLead.enquiryDate}</div>
                    <div><strong>Vertical:</strong> {selectedLead.vertical || '—'}</div>
                    <div><strong>Activity:</strong> {selectedLead.activity || '—'}</div>
                    <div><strong>Status:</strong> <span className={`mgr-status ${getStatusClass(selectedLead.status)}`}>{selectedLead.status}</span></div>
                  </div>
                </div>
                <div className="mgr-view-section">
                  <h4>Payment & Description</h4>
                  <div className="mgr-view-grid">
                    <div><strong>Amount:</strong> ₹{selectedLead.amount?.toLocaleString() || '0'}</div>
                    <div><strong>Payment Status:</strong> {selectedLead.isFree ? <span className="mgr-free-badge">Free Lead</span> : selectedLead.paymentStatus}</div>
                    <div className="mgr-full-width"><strong>Description:</strong> {selectedLead.description || '—'}</div>
                    <div className="mgr-full-width"><strong>Remarks:</strong> {selectedLead.remarks || '—'}</div>
                  </div>
                </div>
              </div>
            </div>
            <div className="mgr-modal-footer">
              <button className="mgr-close-button" onClick={() => setIsViewModalOpen(false)}>Close</button>
            </div>
          </div>
        </div>
      )}

      {/* Assign Modal */}
      {isAssignModalOpen && selectedLead && (
        <div className="mgr-modal-overlay" onClick={() => setIsAssignModalOpen(false)}>
          <div className="mgr-modal" onClick={(e) => e.stopPropagation()}>
            <div className="mgr-modal-header">
              <h3>👥 Reassign Lead</h3>
              <button className="mgr-modal-close" onClick={() => setIsAssignModalOpen(false)}>×</button>
            </div>
            <div className="mgr-modal-body">
              <p>Reassign lead <strong>"{selectedLead.leadName}"</strong> to another team member:</p>
              <select 
                className="mgr-assign-select" 
                value={selectedAssignee} 
                onChange={(e) => setSelectedAssignee(e.target.value)}
              >
                {assigneeOptions.map(opt => (
                  <option key={opt} value={opt}>{opt}</option>
                ))}
              </select>
              <div className="mgr-exec-list">
                <h4 style={{marginBottom: '8px', fontSize: '13px', color: '#2c5f8a'}}>Team Member Workload</h4>
                {teamMembers.map(member => (
                  <div key={member.id} className="mgr-exec-item">
                    <span className="mgr-exec-name">{member.name}</span>
                    <span className="mgr-exec-leads">{member.currentLoad}/{member.maxLoad} leads</span>
                  </div>
                ))}
              </div>
            </div>
            <div className="mgr-modal-footer">
              <button className="mgr-cancel-button" onClick={() => setIsAssignModalOpen(false)}>Cancel</button>
              <button className="mgr-assign-submit" onClick={handleReassignLead}>Reassign Lead</button>
            </div>
          </div>
        </div>
      )}

      {/* Bulk Upload Modal */}
      {isBulkUploadModalOpen && (
        <div className="mgr-modal-overlay" onClick={() => setIsBulkUploadModalOpen(false)}>
          <div className="mgr-modal mgr-large-modal" onClick={(e) => e.stopPropagation()}>
            <div className="mgr-modal-header">
              <h3>📤 Bulk Upload Leads</h3>
              <button className="mgr-modal-close" onClick={() => setIsBulkUploadModalOpen(false)}>×</button>
            </div>
            <div className="mgr-modal-body">
              <p className="mgr-bulk-instruction">Paste CSV data (columns order):</p>
              <div className="mgr-bulk-example">
                <strong>Format:</strong> Name, Mobile, Email, WhatsApp, Company, Source, Location, Assignee, Description, Vertical, Activity, Remarks, Date, Amount, IsFree<br /><br />
                <strong>Example:</strong><br />
                John Doe, +91 9876543210, john@email.com, +91 9876543210, Tech Corp, Referral, Mumbai, Priya (Exec), Need ERP, IT, Demo done, Follow up, 2024-01-20, 25000, false
              </div>
              <textarea 
                className="mgr-bulk-textarea" 
                value={bulkData} 
                onChange={(e) => setBulkData(e.target.value)} 
                placeholder="Paste CSV data here..." 
                rows="10" 
              />
            </div>
            <div className="mgr-modal-footer">
              <button className="mgr-cancel-button" onClick={() => setIsBulkUploadModalOpen(false)}>Cancel</button>
              <button className="mgr-upload-button" onClick={handleBulkUpload}>Upload</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ManagerSourcing;